export const integrationsRouteNames = {
  default: 'integration-v2',
  appUpgradePlans: 'location_integration_app_upgrade_plans',
  appAnyApp: 'location_integration_app_any_app',
  appVersion: 'location_integration_app_version',
  updateApp: 'location_integration_update_app',
  subRoute:'location_integration_app_any_app',
  notFound: 'location_integration_not_found',
}
